// extracted by mini-css-extract-plugin
module.exports = {"component":"BannerHero_component_Xn1Kh"};